export default "__VITE_ASSET__D3hS8cBc__"